var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCostOfLivingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1401 0.293189C13.9443 0.0985384 13.6273 0.0991741 13.4322 0.294608L6.24669 7.49285C6.18686 7.55279 6.14327 7.6269 6.12 7.70825L5.40702 10.2011C5.36383 10.3521 5.5041 10.4915 5.65527 10.4478L8.15082 9.7264C8.23225 9.70286 8.30636 9.65907 8.36619 9.59913L13.6413 4.31472L11.5307 2.20411L12.2378 1.497L14.3478 3.60699L15.5517 2.40089C15.7468 2.20545 15.7462 1.88923 15.5503 1.69458L14.1401 0.293189Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V13.9C14 13.9552 13.9552 14 13.9 14H2.1C2.04477 14 2 13.9552 2 13.9V2.1C2 2.04477 2.04477 2 2.1 2H8",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCostOfLivingIcon);
export default __webpack_public_path__ + "static/media/edit-cost-of-living-icon.9187218d30b6d1ca3cec066b36b36d50.svg";
export { ForwardRef as ReactComponent };